import React, { FC } from "react";
import {
  AppTextField,
  AppInput,
  AppModal,
  AppFormErrorText,
} from "../../theme";
import t from "../../localization/en/translation.json";
import { IClientSizes } from "../../models/IAdminClientSizes";
import { validateFormInputForSpecialChar } from "../../utils/helper-utility";
import "./adminClientSizesModal.scss";

interface IProps {
  isOpen: boolean;
  onClose: Function;
  onConfirm: Function;
  onUpdateDescription: Function;
  selectedClientSize: IClientSizes | null;
  description: string;
}

const AdminClientSizesModal: FC<IProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedClientSize,
  onUpdateDescription,
  description,
}) => {
  const renderRegionName = () => (
    <div className="admin-client-sizes-modal-input">
      <AppInput
        value={selectedClientSize ? selectedClientSize.name : ""}
        autoComplete="off"
        label={t.admin_client_size_modal_name}
        disabled
      />
    </div>
  );

  const renderRegionDescription = () => (
    <div className="admin-client-sizes-modal-textarea">
      <AppTextField
        maxLength={100}
        value={description}
        label={t.admin_client_size_modal_desc}
        onChange={({ target }) => onUpdateDescription(target.value)}
      />
      {validateFormInputForSpecialChar(description) && (
        <AppFormErrorText>
          {t.all_ssp_validate_special_character_in_text_error.replace(
            "{1}",
            description.trim().split("")[0]
          )}
        </AppFormErrorText>
      )}
    </div>
  );

  return (
    <AppModal
      size="md"
      showModal={isOpen}
      onModalClose={() => onClose()}
      onConfirm={() => onConfirm({ ...selectedClientSize, description })}
      cancelBtnText={t.cancel}
      confirmBtnText={t.edit_project_update}
      title={t.admin_client_size_modal_title}
      disabledValue={validateFormInputForSpecialChar(description)}
    >
      <div className="admin-client-sizes-modal-content">
        {renderRegionName()}
        {renderRegionDescription()}
      </div>
    </AppModal>
  );
};

export default AdminClientSizesModal;
